import { Vue, Component, Prop } from 'vue-property-decorator'
import { default as TReview } from '~/types/api/Review'
import RatingStars from '~/components/element/RatingStars'

@Component
export default class Review extends Vue {
  @Prop({ type: Object, required: true })
  readonly review!: TReview

  render () {
    const { review } = this
    return (
      <div class="review">
        <div class="review__header">
          <div class="review__username">{ review.username }</div>
          <div class="review__rating">
            <RatingStars {...{
              props: {
                rating: review.rating
              }
            }} />

            <span class="review__date">{ review.date }</span>
          </div>
        </div>

        <div class="review__content">{ review.text }</div>
      </div>
    )
  }
}
